import { Money } from "models/money";
import { Unit } from "models/unit";

export function getExcelData(products) {
  let rows = [];
  let count = 1;
  products.forEach((product) => {
    var _known = {
      Numero: count,
      Nombre: product.name,
      Presentacion: product.presentation,
      "I Trimestre. Unidades Vendidas": Unit(product.quarter1Quantity),
      "I Trimestre. Ventas": Money(product.quarter1Sales),
      "I Trimestre. Valor Unitario": Money(product.valorUnitarioQuarter1),
      "II Trimestre. Unidades Vendidas": Unit(product.quarter2Quantity),
      "II Trimestre. Ventas": Money(product.quarter2Sales),
      "II Trimestre. Valor Unitario": Money(product.valorUnitarioQuarter2),
      "III Trimestre. Unidades Vendidas": Unit(product.quarter3Quantity),
      "III Trimestre. Ventas": Money(product.quarter3Sales),
      "III Trimestre. Valor Unitario": Money(product.valorUnitarioQuarter3),
      "IV Trimestre. Unidades Vendidas": Unit(product.quarter4Quantity),
      "IV Trimestre. Ventas": Money(product.quarter4Sales),
      "IV Trimestre. Valor Unitario": Money(product.valorUnitarioQuarter4),
      "Unidades Vendidas(Total)": Unit(product.totalQuantity),
      "Ventas Totales ($)": Money(product.totalSales),
      "Valor Unitario Total": Money(product.valorUnitario),
    };
    rows.push(_known);
    count++;
  });
  return rows;
}
